var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentImport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#document--import_svg__clip0_61530_7332)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 14.25h-9.877l1.934-1.943L12 11.25 8.25 15 12 18.75l1.057-1.058-1.934-1.942H21v-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 10.5v-3a.748.748 0 00-.218-.532l-5.25-5.25A.75.75 0 0012 1.5H4.5A1.5 1.5 0 003 3v18a1.5 1.5 0 001.5 1.5h12A1.5 1.5 0 0018 21v-1.5h-1.5V21h-12V3h6v4.5A1.5 1.5 0 0012 9h4.5v1.5H18zm-6-3V3.308L16.192 7.5H12z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "document--import_svg__clip0_61530_7332"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgDocumentImport;